import * as yup from "yup";

export const schema = yup.object().shape({
  name: yup.string().required("Name is required field"),
  cityname: yup.string().required("City is required field"),
  address: yup.string().required("Address is required field"),
  pincode: yup.string().required("Pincode is required field"),
  phone: yup.string().required("Phone No. is required field"),
  countrycode: yup.string().required("Country is required field"),
});

export const getTextfieldBasicData = (name, phone) => [
  {
    label: "Name",
    value: name,
    onChangeField: "name",
  },
  {
    label: "Phone No.",
    value: phone,
    onChangeField: "phone",
  },
];

export const getTextfieldData = (address, pincode, cityname) => [
  {
    label: "Address",
    value: address,
    onChangeField: "address",
  },
  {
    label: "Pincode",
    value: pincode,
    onChangeField: "pincode",
  },
  {
    label: "City",
    value: cityname,
    onChangeField: "cityname",
  },
];

export const getButtonData = (onFinish, cancelEdit, hasError, isTouched) => [
  {
    name: "Update",
    onClick: onFinish,
    type: "primary",
    variant: "contained",
    disabled: hasError() || !isTouched(),
  },
  {
    name: "Cancel",
    onClick: cancelEdit,
    type: "primary",
    variant: "outlined",
    disabled: false,
  },
];


export const getRadioButtonData = (verify) => [
  {
    label: "Verify",
    value: verify,
    onChangeField: "verify",
  },
];

export const getSelectFieldData = (countrycode) => [
  {
    label: "Country",
    value: countrycode,
    onChangeField: "countrycode",
  },
];

